import React, { FC } from 'react';
import { Box, Heading, SegmentedControl, SegmentedControlOption, SegmentedControlSize } from '@bechtel/gds';
import { UNIT_OF_MEASURE } from '../types';
import { Trans } from '@lingui/macro';

interface ThreeWeekLookAheadHeaderProps {
  unitOfMeasure: UNIT_OF_MEASURE;
  setUnitOfMeasure: React.Dispatch<React.SetStateAction<UNIT_OF_MEASURE>>;
  disabled: boolean;
}

export const ThreeWeekLookAheadHeader: FC<ThreeWeekLookAheadHeaderProps> = ({
  unitOfMeasure,
  setUnitOfMeasure,
  disabled,
}) => {
  return (
    <Box flexDirection={{ sm: 'row' }} py={{ sm: '400' }} alignItems={{ sm: 'center' }}>
      <Box pl={{ sm: '500' }}>
        <Heading size="400" weight="600">
          <Trans>Three-Week Look Ahead (3WLA)</Trans>
        </Heading>
      </Box>
      <Box pr={{ sm: '500' }} style={{ marginLeft: 'auto' }}>
        <SegmentedControl segmentSize={SegmentedControlSize.SMALL}>
          <SegmentedControlOption
            selected={unitOfMeasure === UNIT_OF_MEASURE.HOUR}
            onClick={() => {
              setUnitOfMeasure(UNIT_OF_MEASURE.HOUR);
            }}
            segmentSize={SegmentedControlSize.SMALL}
            disabled={disabled}
          >
            <Trans>Hours</Trans>
          </SegmentedControlOption>
          <SegmentedControlOption
            selected={unitOfMeasure === UNIT_OF_MEASURE.LINEAR_FEET}
            onClick={() => {
              setUnitOfMeasure(UNIT_OF_MEASURE.LINEAR_FEET);
            }}
            segmentSize={SegmentedControlSize.SMALL}
            disabled={disabled}
          >
            <Trans>Linear Feet</Trans>
          </SegmentedControlOption>
          <SegmentedControlOption
            selected={unitOfMeasure === UNIT_OF_MEASURE.MILESTONE}
            onClick={() => {
              setUnitOfMeasure(UNIT_OF_MEASURE.MILESTONE);
            }}
            segmentSize={SegmentedControlSize.SMALL}
            disabled={disabled}
          >
            <Trans>Milestones</Trans>
          </SegmentedControlOption>
        </SegmentedControl>
      </Box>
    </Box>
  );
};
